export default __webpack_public_path__ + "static/media/ic_marker.df4e8eef.svg";